import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import logow from "./logo-white.svg";
import React from "react";
import Modal from "react-bootstrap/Modal";

import "./Footer.css";
function Footer() {
  const [modalShow, setModalShow] = React.useState(false);
  const handleClose = () => {
    setModalShow(false);
  };
  return (
    <footer className="d-flex pt-5 pb-5 justify-content-center mt-auto bg-dark">
      <div className="foot container text-white">
        <div className="row">
          <div className="col-6 col-lg-3">
            <div className="text-start ">
              <h6 className="fw-bold ">
                <small>CONTACT</small>
              </h6>
              <p>info@hackoffee.uy</p>
              <p>T: +5982 7121234</p>
              <p className="mb-3">
                <i className="fa-brands fa-instagram me-4 fa-xl	"></i>
                <i className="fa-brands fa-spotify fa-xl	"></i>
              </p>
              <p>Privacy policy</p>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="text-start ">
              <h6 className="fw-bold ">
                <small>LOCALS</small>
              </h6>
              <p>Local</p>
              <p>2123 Street</p>
              <p>9:00 AM- 6:00 PM</p>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="text-start ">
              <h6 className="fw-bold ">
                <small>SHOP</small>
              </h6>
              <p>Coffee</p>
              <p>Sweets</p>
              <p>Tea</p>
            </div>
          </div>

          <div className="col-6 col-lg-3 text-start">
            <h4>Subscribe</h4>
            <Form>
              <Form.Group className="mb-3" controlId="formBasicEmail">
                <Form.Label></Form.Label>
                <Form.Control type="email" placeholder="Enter your e-mail" />
              </Form.Group>
              <Button
                className="btn bg-color-green btn-light text-white "
                onClick={() => setModalShow(true)}
              >
                Send
              </Button>
            </Form>
          </div>
        </div>

        <hr className="text-white " />
        <div className="row justify-content-between align-items-center mt-4 mb-4">
          <div className="col-6 col-lg-3">
            <p className="text-start mb-0">© 2022 Hackoffee</p>
          </div>
          <div className="col-6 col-lg-3 text-end">
            <img className="logo" src={logow} alt="logo" />
          </div>
        </div>
      </div>
      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
      >
        <Modal.Header>
          <h3>Thank you very much!!</h3>
        </Modal.Header>
        <Modal.Body>
          <p className="fs-5 text-secondary">
            This functionality was out of the scope of our project.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="bg-color-green" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </footer>
  );
}

export default Footer;
